
import React, { useEffect, useState } from 'react';
import NpsService from '../../services/resource/npsService';
import BranchService from '../../services/resource/branchService';
import { useFormik } from 'formik';
import * as Yup from "yup";
import DropDown from '../../components/dropdown/dropdown';
import TextareaForm from '../../components/textarea/textarea';
import ButtonLoading from '../../components/buttonLoading/buttonLoading';
import Card from '../../components/card/card';
import { useAuth } from '../../context/authContext';
import { toast } from 'react-toastify';
import { ratingOption } from '../../utils/options';
import InputFormMask from '../../components/inputMask/inputMask';
import ClientService from '../../services/resource/clientService';
import { formatClientCode } from '../../utils/formatClientCode';
import OrderService from '../../services/resource/orderService';
import { useNavigate, useParams } from 'react-router-dom';
import { formatRomaneio } from '../../utils/formatRomaneio';

const initialValues = {
    branch: '',
    branchCode: '',
    clientCode: null,
    fantasyName: '',
    teamApproach: null,
    teamApproachNotes: '',
    storageCheck: null,
    storageCheckNotes: '',
    productQuality: null,
    productQualityNotes: '',
    issueResolution: null,
    issueResolutionNotes: '',
    deliveryTime: null,
    deliveryTimeNotes: '',
    npsScore: null,
    finalNotes: '',
    orderId: null,
    employeeId: null
}

const initialClient = {
    id: null,
    code: null,
    name: null,
    addressId: null,
    branchId: null,
    branchName: null,
    addressStreet: null,
    addressNeighborhood: null,
    addressCity: null,
    addressUf: null,
    phone1: '',
    phone2: '',
}

const initialOrder = {
    branchCode: null,
    branchId: null,
    branchName: null,
    clientCity: null,
    clientCode: null,
    clientId: null,
    clientName: null,
    clientUf: null,
    createDate: null,
    id: null,
    npsId: null,
    orderValue: null,
    romaneioDate: null,
    romaneioDriverId: null,
    romaneioDriverName: null,
    romaneioId: null
}

function NpsForm() {
    const service = new NpsService();
    const branchService = new BranchService();
    const clientService = new ClientService();
    const orderService = new OrderService();

    const navigate = useNavigate()
    const { user } = useAuth();
    const { branchCode, clientCode, idOrder } = useParams();
    const [client, setClient] = useState(initialClient);
    const [order, setOrder] = useState(initialOrder);
    const [orders, setOrders] = useState([]);
    const [clients, setClients] = useState([]);
    const [search, setSearch] = useState("");
    const [branches, setBranches] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showModalClient, setShowModalClient] = useState(false);
    const [showModalOrder, setShowModalOrder] = useState(false);
    const [messageError, setMessageError] = useState('');
    const [messageOrderError, setMessageOrderError] = useState('');
    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: Yup.object({
            clientCode: Yup.string().required("Campo obrigatório"),
        })
    });

    useEffect(() => {
        branchService.findAll().then(response => {
            setBranches(response.data)
        });

        if (clientCode && idOrder && branchCode) {
            formik.values.branchCode = branchCode;
            client.code = clientCode
            loadOrderById(idOrder)
            const codigoCliente = (clientCode).replaceAll("-", "").replaceAll(" ", "");
            loadClientById(codigoCliente)
        }
    }, []);

    useEffect(() => {
        if (!branchCode) {
            setOrder(prev => ({ ...prev, id: formik.values.branchCode }))
            setClient(prev => ({ ...prev, id: null, code: formik.values.branchCode }))
        }
    }, [formik.values.branchCode]);

    const handleClient = (value) => {
        if (value.length < 14) {
            setMessageError(null);
            setClient(initialClient)
        }
        if (value.length === 14) {
            const codigoCliente = value.replaceAll("-", "").replaceAll(" ", "")
            loadClientById(codigoCliente)
        }

        setClient(prev => ({ ...prev, code: value }))
    }

    const loadClientById = (value) => {
        clientService.findByCode(value).then(response => {
            const data = response.data;
            setClient(() => ({
                code: data.code,
                name: data.name,
                fantasyName: data.fantasyName,
                addressStreet: data.addressStreet,
                addressNeighborhood: data.addressNeighborhood,
                addressUf: data.addressUf,
                addressCity: data.addressCity,
                branchName: data.branchName,
                phone1: data.phone1,
                phone2: data.phone2
            }));
            setMessageError('');
        }).catch(error => {
            toast.error("Código do Cliente não existe nessa base de dados")
            setMessageError(error.response.data.message);
        })
    }

    const loadOrderById = (codigoPedido) => {
        orderService.findById(codigoPedido).then(response => {
            const data = response.data;
            setOrder(data)
            setMessageOrderError(null);
        }).catch(error => {
            setMessageOrderError(error.response.data.message);
            toast.error(error.response.data.message)
        })
    }

    const handleOrder = (value) => {
        if (value.length === 20) {
            const codigoPedido = (value.replaceAll('/', '').replaceAll(' ', ''))
            loadOrderById(codigoPedido);
        }

        setOrder(prev => ({ ...prev, id: value }))
    }

    const loadClients = async () => {
        try {
            const response = await clientService.findAll({ name: search, branchCode: formik.values.branchCode }, 10, 0);
            setClients(response.data.content);
        } catch (error) {
            console.error('Erro ao carregar clientes', error);
        }
    };

    const searchClient = () => {
        setShowModalClient(true);
        loadClients();
        setSearch("");
    }

    const searchOrder = () => {
        setShowModalOrder(true);
        orderService.findByClientCode(client.code).then(response => {
            setOrders(response.data);
        }).catch(error => {

        });

        setSearch("");
    }

    useEffect(() => {
        loadClients()
    }, [search])

    const cancelSearchClients = () => {
        setShowModalClient(false);
        setSearch("")
    }

    const selectedClient = (client) => {
        setClient({
            code: client.code,
            name: client.name,
            fantasyName: client.fantasyName,
            branchName: client.branchName,
            addressStreet: client.addressStreet,
            addressNeighborhood: client.addressNeighborhood,
            addressUf: client.addressUf,
            addressCity: client.addressCity,
        });
        setShowModalClient(false);
        setMessageError(null);
    }

    const setSelectedOrder = (value) => {
        setOrder(value);
        setShowModalOrder(false);
        setMessageOrderError(null)
    }

    const handleRadioChange = (name, value) => {
        formik.setValues(prev => ({ ...prev, [name]: value }))
    };

    const handleNpsScore = (value) => {
        formik.setValues(prev => ({ ...prev, npsScore: value }))
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        formik.values.employeeId = user.userid;
        formik.values.clientCode = client.code;
        formik.values.orderId = order.id;

        try {
            service.validate(formik.values);
        } catch (error) {
            error.message.map(x => toast.error(x))
            setLoading(false);
            return false;
        }

        try {
            await service.create(formik.values);
            toast.success("Avaliação enviada. Obrigado!")
            setLoading(false);
            formik.setValues(initialValues);
            setClient(initialClient);
            setOrder(initialOrder)
            navigate("/nps/consulta")
        } catch (error) {
            console.error(error);
            toast.error(error.response.data.message || 'Erro ao enviar avaliação. Tente novamente.');

        } finally { setLoading(false) }
    };

    const renderRatingOptions = (name) => (
        <div className="grid grid-cols-4 gap-4">
            {ratingOption.map((data) => (
                <label key={data.label} className={`rating-option cursor-pointer ${formik.values[name] === data.value ? 'selected' : ''}`}>
                    <input type="radio" name={name} value={data.value} className="hidden"
                        onChange={() => handleRadioChange(name, data.value)} />
                    <div className="flex flex-col items-center p-3 border rounded-lg hover:border-blue-500">
                        <div className={`rating-icon text-2xl mb-1 ${data.value === 0 ? 'text-red-500' : data.value === 1 ? 'text-yellow-500' : data.value === 2 ? 'text-blue-500' : 'text-green-500'}`}>
                            <i className={`fas ${data.value === 0 ? 'fa-frown' : data.value === 1 ? 'fa-meh' : data.value === 3 ? 'fa-smile' : 'fa-grin-stars'}`} />
                        </div>
                        <span className="text-sm capitalize">{data.label}</span>
                    </div>
                </label>
            ))}
        </div>
    );

    return (
        <div className='w-full '>
            <Card title="Nova Avaliação NPS - Entrega" >
                <form className='grid gap-4' onSubmit={handleSubmit}>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        <div>
                            <DropDown
                                id="cadastroBranchId"
                                label="Filial"
                                label1="name"
                                optionValue="code"
                                optionLabel="name"
                                name="branchCode"
                                disabled={loading}
                                value={formik.values.branchCode}
                                options={branches}
                                invalid={formik.touched.branchCode && formik.errors.branchCode}
                                onBlur={formik.handleBlur}
                                onChange={formik.handleChange}
                            />
                        </div>

                        <div className="flex items-center space-x-2">
                            <div>
                                <InputFormMask
                                    name="code"
                                    label="Código do Cliente"
                                    placeholder="Código do Cliente"
                                    value={client.code}
                                    onChange={(e) => handleClient(e.target.value)}
                                    disabled={!formik.values.branchCode}
                                    mask="9999 9999-9999"
                                />
                                <label className='text-sm text-red-600'>{messageError}</label>
                            </div>
                            <div className='flex h-100 items-end justify-center align-bottom'>
                                <button
                                    type='button'
                                    className="bg-indigo-500 text-white px-4 py-2 rounded hover:bg-indigo-600"
                                    disabled={!formik.values.branchCode}
                                    onClick={searchClient}
                                >
                                    <i className='fas fa-search' />
                                </button>
                            </div>
                        </div>
                        <div className="flex items-center space-x-2">
                            <div>
                                <InputFormMask
                                    name="id"
                                    label="N° do Pedido"
                                    placeholder="Código do Pedido"
                                    value={order.id}
                                    onChange={(e) => handleOrder(e.target.value)}
                                    disabled={!formik.values.branchCode}
                                    mask="9999 999999999999999999"
                                />
                                <label className='text-sm text-red-600'>{messageOrderError}</label>
                            </div>
                            <div className='flex h-100 items-end justify-center align-bottom'>
                                <button
                                    type='button'
                                    className="bg-indigo-500 text-white px-4 py-2 rounded hover:bg-indigo-600"
                                    disabled={!formik.values.branchCode}
                                    onClick={searchOrder}
                                >
                                    <i className='fas fa-search' />
                                </button>
                            </div>
                        </div>
                    </div>
                    {client.id !== null &&
                        <div id="selectedCustomerInfo" class="mt-6 ">
                            <div class="bg-white rounded-lg shadow-md p-4 mb-6 border-l-4 border-blue-500">
                                <div class="flex justify-between items-start">
                                    <div>
                                        <h3 class="text-xl font-semibold text-gray-800" id="customerNameDisplay">{client.name}</h3>
                                        <p class="text-gray-600 text-sm" id="customerCodeDisplay">{client.fantasyName} ({client.code})</p>
                                    </div>

                                </div>

                                <div class="mt-3 grid grid-cols-1 md:grid-cols-3 gap-3">
                                    <div class="flex items-start">
                                        <i class="fas fa-map-marker-alt text-gray-400 mt-1 mr-2"></i>
                                        <div>
                                            <p class="text-gray-800 font-medium" id="customerStreetDisplay">{client.addressStreet}</p>
                                            <p class="text-gray-600 text-sm" id="customerNeighborhoodDisplay">{client.addressNeighborhood || 'Endereço não cadastrado'}</p>
                                        </div>
                                    </div>
                                    <div class="flex items-start">
                                        <i class="fas fa-city text-gray-400 mt-1 mr-2"></i>
                                        <div>
                                            <p class="text-gray-800 font-medium" id="customerCityDisplay">{client.addressCity || "Cidade não cadastrada"}</p>
                                            <p class="text-gray-600 text-sm" id="customerUfDisplay">{client.addressUf || "UF não Cadastrada"}</p>
                                        </div>
                                    </div>
                                    <div class="flex items-start">
                                        <i class="fas fa-phone text-gray-400 mt-1 mr-2"></i>
                                        <div>
                                            <p class="text-gray-800" id="customerBranchDisplay">{client.phone1 || "Telefone não cadastrado"}</p>
                                            <p class="text-gray-800" id="customerBranchDisplay">{client.phone2}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {order.romaneioId !== null &&
                        <div id="selectedCustomerInfo">
                            <div class="bg-white rounded-lg shadow-md p-4 mb-6 border-l-4 border-red-500">
                                <div class="flex justify-between items-start">
                                    <div>
                                        <h3 class="text-xl font-semibold text-gray-800" id="customerNameDisplay">Pedido </h3>
                                        <p class="text-gray-600 text-sm" id="customerCodeDisplay">{order.id.substring(4)}</p>
                                    </div>

                                </div>

                                <div class="mt-3 grid grid-cols-1 md:grid-cols-3 gap-3">
                                    <div class="flex items-start">
                                        <i class="fas fa-box text-gray-400 mt-1 mr-2"></i>
                                        <div>
                                            <p class="text-gray-800 font-medium" id="customerCityDisplay">Romaneio/Transporte</p>
                                            <p class="text-gray-600 text-sm" id="customerUfDisplay">{formatRomaneio(order.romaneioId)}</p>
                                        </div>
                                    </div>
                                    <div class="flex items-start">
                                        <i class="fas fa-id-card text-gray-400 mt-1 mr-2"></i>
                                        <div>
                                            <p class="text-gray-800 font-medium" id="customerStreetDisplay">{order.romaneioDriverName || "Nome não Informado"}</p>
                                            <p class="text-gray-600 text-sm" id="customerNeighborhoodDisplay">{order.romaneioDriverId.substring(4)}</p>
                                        </div>
                                    </div>

                                    <div class="flex items-start">
                                        <i class="fas fa-user-plus text-gray-400 mt-1 mr-2"></i>
                                        <div>
                                            <p class="text-gray-800 font-medium" id="customerBranchDisplay">
                                                {order.romaneioDriverassistant1Id ?
                                                    <>
                                                        {order.romaneioDriverassistant1Id.substring(4)} - {order.romaneioDriverassistant1Name || "Nome não cadastrado"}
                                                    </>
                                                    : "Ajudante não informado"
                                                }
                                            </p>
                                            <p class="text-gray-600 text-sm" id="customerNeighborhoodDisplay">
                                                {order.romaneioDriverassistant2Id ?
                                                    <>
                                                        {order.romaneioDriverassistant2Id.substring(4)} - {order.romaneioDriverassistant2Name || "Nome não cadastrado"}
                                                    </>
                                                    : "Ajudante não informado"
                                                }
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    <div>
                        <h3 className="font-medium">Abordagem da Equipe</h3>
                        <div className="flex flex-col md:flex-row gap-2 mt-2">
                            <div className="md:w-1/2 w-full">
                                {renderRatingOptions('teamApproach')}
                            </div>
                            <div className="md:w-1/2 flex w-full">
                                <TextareaForm
                                    optional
                                    name="teamApproachNotes"
                                    placeholder="Observação"
                                    className="w-full border rounded px-4 py-2"
                                    value={formik.values.teamApproachNotes}
                                    onChange={formik.handleChange}
                                />
                            </div>
                        </div>
                    </div>

                    <div>
                        <h3 className="font-medium">Armazenamento e Conferência</h3>
                        <div className="flex flex-col md:flex-row gap-2 mt-2">
                            <div className="md:w-1/2 w-full">
                                {renderRatingOptions('storageCheck')}
                            </div>
                            <div className="md:w-1/2 flex w-full">
                                <TextareaForm
                                    optional
                                    name="storageCheckNotes"
                                    placeholder="Observação"
                                    value={formik.values.storageCheckNotes}
                                    onChange={formik.handleChange}
                                />
                            </div>
                        </div>
                    </div>

                    <div>
                        <h3 className="font-medium">Qualidade dos Produtos</h3>
                        <div className="flex flex-col md:flex-row gap-2 mt-2">
                            <div className="md:w-1/2 w-full">
                                {renderRatingOptions('productQuality')}
                            </div>
                            <div className="md:w-1/2 flex w-full">
                                <TextareaForm
                                    optional
                                    name="productQualityNotes"
                                    placeholder="Observação"
                                    value={formik.values.productQualityNotes}
                                    onChange={formik.handleChange}
                                />
                            </div>
                        </div>
                    </div>

                    <div>
                        <h3 className="font-medium">Resolução de Avarias e Faltas</h3>
                        <div className="flex flex-col md:flex-row gap-2 mt-2">
                            <div className="md:w-1/2 w-full">
                                {renderRatingOptions('issueResolution')}
                            </div>
                            <div className="md:w-1/2 flex w-full">
                                <TextareaForm
                                    name="issueResolutionNotes"
                                    placeholder="Observação"
                                    optional
                                    value={formik.values.issueResolutionNotes}
                                    onChange={formik.handleChange}
                                />
                            </div>
                        </div>
                    </div>

                    <div>
                        <h3 className="font-medium">Prazo e Horário de Entrega</h3>
                        <div className="flex flex-col md:flex-row gap-2 mt-2">
                            <div className="md:w-1/2 w-full">
                                {renderRatingOptions('deliveryTime')}
                            </div>
                            <div className="md:w-1/2 flex w-full">
                                <TextareaForm
                                    name="deliveryTimeNotes"
                                    placeholder="Observação"
                                    optional
                                    value={formik.values.deliveryTimeNotes}
                                    onChange={formik.handleChange}
                                />
                            </div>
                        </div>
                    </div>

                    <div>
                        <h3 className="font-medium">Nota de 0 a 10 para nosso serviço:</h3>
                        <div className="flex flex-wrap gap-3">
                            {[...Array(11).keys()].map((n) => (
                                <button type="button" key={n} onClick={() => handleNpsScore(n)}
                                    className={`nps-option w-10 h-10 mt-3 rounded-full flex items-center justify-center ${formik.values.npsScore === n ? 'bg-blue-600 text-white font-bold' : 'bg-gray-200'}`}>{n}</button>
                            ))}
                        </div>
                    </div>

                    <div>
                        <TextareaForm
                            label="Observação final"
                            name="finalNotes"
                            placeholder="Observação final"
                            value={formik.values.finalNotes}
                            onChange={formik.handleChange} />
                    </div>

                    <div className="flex justify-end">
                        <ButtonLoading
                            type="submit"
                            label="Salvar Avaliação"
                            icon="fa fa-save"
                            loading={loading}
                            color="indigo"
                        />
                    </div>
                </form>
            </Card>
            {showModalClient &&
                <div id="client-modal" className="fixed inset-0 z-50">
                    <div className="modal-overlay absolute inset-0 bg-black bg-opacity-50"></div>
                    <div className="flex items-center justify-center min-h-screen p-4" >
                        <div className="modal-content bg-white rounded-lg shadow-xl w-full max-w-md max-h-[80vh] flex flex-col">
                            <div className="p-4 border-b border-gray-200">
                                <div className="flex justify-between items-center">
                                    <h2 className="text-xl font-semibold text-gray-800">Selecionar Cliente</h2>
                                    <button id="close-modal" className="text-gray-500 hover:text-gray-700">
                                        <i onClick={cancelSearchClients} className="fas fa-times"></i>
                                    </button>
                                </div>

                                <div className="mt-4 relative">
                                    <input
                                        type="text"
                                        id="modal-search"
                                        name='search'
                                        className="w-full px-4 py-2 border-1 border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
                                        placeholder="Pesquisar clientes..."
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                    />
                                    <i className="fas fa-search absolute right-3 top-3 text-gray-400"></i>
                                </div>
                            </div>

                            <div className="client-list overflow-y-auto flex-1">
                                <ul id="client-list" className="divide-y divide-gray-200">
                                    {clients.map(client =>
                                        <li className='p-4 hover:bg-gray-50 cursor-pointer transition' onClick={() => selectedClient(client)}>
                                            <div className="flex items-center">
                                                <div className="flex-shrink-0 h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600">
                                                    <i className="fas fa-user"></i>
                                                </div>
                                                <div className="ml-4">
                                                    <h3 className="text-sm font-medium text-gray-900">{client.name}</h3>
                                                    <p className="text-sm text-gray-500">{formatClientCode(client.code)}</p>
                                                    <p className="text-xs text-gray-400 mt-1">{client.addressStreet || 'Não Cadastrado'}  - {client.addressCity}, {client.addressUf}</p>
                                                </div>
                                            </div>
                                        </li>
                                    )}
                                </ul>
                            </div>

                            <div className="p-4 border-t border-gray-200 flex justify-end">
                                <button id="cancel-button" className="px-4 py-2 text-gray-600 hover:text-gray-800 mr-2" onClick={cancelSearchClients}>
                                    Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {showModalOrder &&
                <div id="customerModal" className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
                    <div className="bg-white rounded-lg shadow-xl w-full max-w-3xl max-h-[90vh] flex flex-col animate-fade-in">
                        <div className="border-b p-4 flex justify-between items-center">
                            <h3 className="text-xl font-semibold text-gray-800">
                                <i className="fas fa-users mr-2 text-blue-500"></i> Selecione um pedido
                            </h3>
                            <button id="closeCustomerModal" className="text-gray-500 hover:text-gray-700" onClick={() => setShowModalOrder(false)}>
                                <i className="fas fa-times"></i>
                            </button>
                        </div>
                        {orders.length < 1 ?
                            <div className='px-6 py-4'>
                                <p className='text-md text-gray-600'>Cliente sem pedidos a serem avaliados.</p>
                            </div>
                            :
                            <div className="flex-1 overflow-y-auto custom-scrollbar">
                                <table className="min-w-full divide-y divide-gray-200">
                                    <thead className="bg-gray-50 sticky top-0">
                                        <tr>
                                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">N° Pedido</th>
                                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cliente Nome</th>
                                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cód Cliente</th>
                                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cód Mot</th>
                                        </tr>
                                    </thead>
                                    <tbody id="customerTableBody" className="bg-white divide-y divide-gray-200">
                                        {orders.map(order => (
                                            <tr className='cursor-pointer hover:bg-gray-200' key={order.id} onClick={() => setSelectedOrder(order)}>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{order.id}</td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{order.clientName}</td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{formatClientCode(order.clientCode)}</td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{(order.romaneioDriverId)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        }

                        <div className="border-t p-4 flex justify-between items-center">
                            <div className="text-sm text-gray-500" id="customerCount">{orders.length} pedidos encontrados</div>
                            <div className="flex space-x-2">
                                <button id="cancelCustomerSelection" className="px-4 py-2 border rounded-lg text-gray-700 hover:bg-gray-100" onClick={() => setShowModalOrder(false)}>
                                    Cancelar
                                </button>
                                <button id="confirmCustomerSelection" className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed" disabled>
                                    Confirmar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    );
};


export default NpsForm;
